import React, { useEffect, useState } from "react";
import { fetchStoreData } from "../../service/StoreService";
import Select from "react-select";
import { apiService } from "../../service/ApiService";
import { notificationService } from "../../service/NotificationService";
import { Form } from "react-bootstrap";

import { useTranslation } from "react-i18next";

const StoreUserSelect = ({ selectedUsers = [], handler }) => {
  const {
    t,
  } = useTranslation();

  const [users, setUsers] = useState([]);
  const [availableUsers, setAvailableUsers] = useState([]);

  const getUsers = async () => {
    try {
      console.log(selectedUsers);
      const response = await apiService.get(`api/v1/users/clients`);
      const activeUsers = response.data.filter((el) => !el.deleted);
      const availableUsers = activeUsers.map((el) => {
        return {
          value: el.id,
          label: el.username,
        };
      });
      console.log(availableUsers);
      setUsers(availableUsers);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <>
      <Form.Group>
        <label>{t("messages.storeUsers")}</label>
        <Select
          isMulti
          className="primary"
          name="multiSelect"
          onChange={handler}
          value={selectedUsers}
          options={users}
          noOptionsMessage={() => t("messages.noUsersAreAvailableForAssignment")}
          placeholder={t("forms.placeholders.selectStoreUsers")}
        />
      </Form.Group>
    </>
  );
};

export default StoreUserSelect;
